module.exports = __webpack_public_path__ + "media/country_flags/az-e726357a.png";